import base from '../dr-base'
import drFileInput from './dr-file-input.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-file-input',
  name: 'File input',
  group: 'Input widgets',
  icon: 'file-alt',
  ...base,
  properties: {
    ...base.properties,
    Multiple: {
      type: 'boolean',
      name: 'vuetifyWidgets.dr-file-input.multiple',
      default: false
    },
    Disabled: {
      name: 'vuetifyWidgets.dr-file-input.disabled',
      type: 'string',
      default: ''
    },
    Label: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.label'
    },
    FileName: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.fileName',
      component: 'dr-value-editor'
    },
    Value: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.value',
      component: 'dr-value-editor'
    },
    MaxSize: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.maxSize'
    },
    ErrorMessage: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.errorMessage'
    },
    AvailableFileExtensions: {
      type: 'string',
      name: 'vuetifyWidgets.dr-file-input.availableFileExtensions',
      default: ''
    },
    Style: {
      name: 'vuetifyWidgets.dr-file-input.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-time-picker.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drFileInput,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
